export default "__VITE_ASSET__DZbnjpJq__"